import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CurrentTenantService } from '@insolution/tenant-data-access';
import { IHelpAnswer } from '../interfaces/help-answer.interface';
import { IHelpFeedbackRequest } from '../interfaces/help-feedback-request.interface';
import { IHelpRequest } from '../interfaces/help-request.interface';
import { HelpApiClient } from './help-api-client.service';

@Injectable({
  providedIn: 'root',
})
export class HelpService {
  private readonly helpApiClient = inject(HelpApiClient);
  private readonly translateService = inject(TranslateService);
  private readonly currentTenantService = inject(CurrentTenantService);

  public async ask(question: string, sessionId?: string): Promise<IHelpAnswer> {
    const request: IHelpRequest = {
      question,
      sessionId,
      locale: this.translateService.currentLang,
      profile: this.currentTenantService.currentTenantProfile() ?? undefined,
    };
    return this.helpApiClient.post<IHelpAnswer>('/ask', request);
  }

  public async sendFeedback(feedback: IHelpFeedbackRequest): Promise<void> {
    await this.helpApiClient.post<unknown>('/feedback', feedback);
  }
}
